import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/global/back-arrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/global/button.tsx");
